import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './i18n'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/empnewsnewfront">
    <App />
  </BrowserRouter>
);

// reportWebVitals is removed to resolve "Stray start tag script" validation error.
//